module.exports = __webpack_public_path__ + "img/mark.5d01952.webp";